// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3LXGv","rootSmall":"AddTileButton_rootSmall__22_Aj"};